import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForkLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fork_left"}/>
}
